import { Box } from "../../../components/ui/box";
import { Skeleton } from "../../../components/ui/skeleton";

export type WidgetSkeletonVariant = "rows" | "stat" | "bar" | "block";

/**
 * The one loading state every widget body uses — a variant per body shape, so a
 * loading widget silhouettes what it's about to render:
 *  - `rows`  — three text-height lines (lists, bar/line charts).
 *  - `stat`  — one centered stat-sized block (the big-number widgets).
 *  - `bar`   — one full-width bar (single-bar charts).
 *  - `block` — one region filling the body (treemaps, pies, maps).
 * Loading only — a data error still `throw`s to the harness ErrorBoundary.
 */
export function WidgetSkeleton({ variant = "rows" }: { variant?: WidgetSkeletonVariant }) {
  switch (variant) {
    case "stat":
      // 96×44, as exact Tailwind steps.
      return (
        <Box fill align="center" justify="center">
          <Skeleton className="h-11 w-24" />
        </Box>
      );
    case "bar":
      return (
        <Box fill justify="center">
          <Skeleton className="h-10 w-full" />
        </Box>
      );
    case "block":
      return (
        <Box fill direction="column">
          <Skeleton className="h-full w-full" />
        </Box>
      );
    default:
      return (
        <Box fill gap="sm" justify="center">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-4 w-full" />
          ))}
        </Box>
      );
  }
}
